module.exports = __webpack_public_path__ + "img/castellon-plaza.4054c421.png";